import ReactDOM from 'react-dom';
import React from 'react';
import i18n from './App/i18n';
import Main from './App/Main';
import { VisualizationProvider } from './App/ContextProviders/VisualizationProvider';
import { ConfigurationProvider } from './App/ContextProviders/ConfigurationProvider';
import { createVisualization } from './Visualization/createVisualization';
import createWarehouseConfiguration from './App/createWarehouseConfiguration';
import { CustomThemeProvider } from './theme';
import { createObjectControls } from './Visualization/objectControls';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import Store from './App/Store';
import { InitContainer } from './App/InitContainer';
import { LoaderStateProvider } from './App/ContextProviders/LoaderStateProvider';
import { globalLoaderStateManager } from './App/GlobalLoader';
import isDevMode from './Utils/isDevMode';
import ActivePopupProvider from './App/ContextProviders/ActivePopupProvider';
import { Frame } from './App/Frame';
import { addOptionRulesHandler } from './App/Rules/addOptionRulesHandler';
import CountryContainer from './App/CountryContainer';

const configuration = createWarehouseConfiguration();
addOptionRulesHandler(configuration, Store);

const visualization = createVisualization(configuration);
createObjectControls(visualization, configuration);

// expose objects for console hacks in dev mode
if (isDevMode()) {
  window.visualization = visualization;
  window.configuration = configuration;
}

const App = () => (
  <LoaderStateProvider loaderStateManager={globalLoaderStateManager}>
    <ConfigurationProvider configuration={configuration}>
      <VisualizationProvider visualization={visualization}>
        <ActivePopupProvider>
          <CountryContainer>
            <InitContainer>
              <Main />
            </InitContainer>
          </CountryContainer>
        </ActivePopupProvider>
      </VisualizationProvider>
    </ConfigurationProvider>
  </LoaderStateProvider>
);

ReactDOM.render(
  <CustomThemeProvider>
    <I18nextProvider i18n={i18n}>
      <Provider store={Store}>
        <Frame>
          <App />
        </Frame>
      </Provider>
    </I18nextProvider>
  </CustomThemeProvider>,
  document.getElementById('root')
);
